import { anodum, cssGenerator } from '@yola/ws-sdk';
import attributes from '../constants/attributes';

const { CONTENT_POSITION: CONTENT_POSITION_CLASS, POSITION: POSITION_CLASS } =
  cssGenerator.constants.classNames;

function createCompositeItem({
  position = '50%_50%',
  placeholder = true,
  stretched = false,
  aspectRatio = '1',
  mediaGroupId = null,
  dataCreationSequence = '1',
  contentPosition = '50%_50%',
  contentScale = '1',
  width = null,
  src = '',
  alt = '',
  childNode = null,
} = {}) {
  const generatedItem = anodum.parseElementFromString(`
    <ws-composite-item
      class="${POSITION_CLASS}-[${position}] ${width ? `width-[${width}]` : ''}"
      aspect-ratio="${aspectRatio}"
      data-creation-sequence="${dataCreationSequence}"
      ${stretched ? `${attributes.STRETCHED}` : ''}
    >
      <ws-media-container
        ${placeholder ? 'placeholder' : ''}
        ${mediaGroupId ? `media-group-id="${mediaGroupId}"` : ''}
        class="${CONTENT_POSITION_CLASS}-[${contentPosition}]"
        content-scale="${contentScale}"
        aspect-ratio="1"
      >
        <picture>
          <img src="${src}" alt="${alt}" loading="lazy" />
        </picture>
      </ws-media-container>
    </ws-composite-item>
  `);

  if (childNode) {
    const mediaContainer = generatedItem.querySelector('ws-media-container');

    if (mediaContainer) {
      mediaContainer.replaceWith(childNode);
    }
  }

  return generatedItem;
}

export default createCompositeItem;
